import React from 'react';
import Spinner from 'react-spinner-material';
import { FadeIn } from 'components';

const Loading = ({ center, size = 60, width = 5 }) => {
  const style = center ? {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  } : {};
  
  return (
    <FadeIn duration={300}>
      <div style={style}>
        <Spinner size={size} color={"#000"} width={width} visible={true} />
      </div>
    </FadeIn>
  );
};

export default Loading;
